import { render, staticRenderFns } from "./LoansCatalog.vue?vue&type=template&id=18a8da29&scoped=true"
import script from "./LoansCatalog.vue?vue&type=script&lang=js"
export * from "./LoansCatalog.vue?vue&type=script&lang=js"
import style0 from "./LoansCatalog.vue?vue&type=style&index=0&id=18a8da29&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a8da29",
  null
  
)

export default component.exports